import { memo } from "react";

import { Tooltip, Typography } from "neetoui";
import { pluck, sum, values } from "ramda";
import { useTranslation } from "react-i18next";

import DataDistribution from "./DataDistribution";
import MetaInfoItem from "./MetaInfoItem";

import { transformInsights } from "../utils";

const MetaInfo = ({ type, data, defaultItems }) => {
  const { t } = useTranslation();
  const { defaultData, othersData } = transformInsights(data, defaultItems);

  const othersSum = sum(values(pluck("value", othersData)));

  return (
    <div className="neeto-ui-bg-gray-100 neeto-ui-rounded p-4">
      <Typography
        className="mb-2"
        style="body2"
        textTransform="uppercase"
        weight="bold"
      >
        {type}
      </Typography>
      <DataDistribution data={defaultData} />
      <Tooltip
        content={<DataDistribution data={othersData} />}
        disabled={!othersSum}
        position="bottom"
      >
        <div className="mt-2 grid grid-cols-4 gap-2">
          <MetaInfoItem
            name={t("neetoMolecules.insights.others")}
            value={othersSum}
          />
        </div>
      </Tooltip>
    </div>
  );
};

export default memo(MetaInfo);
